// File: src/components/package/SkeletonCard.js
// Last modified: 2025-10-29

import React from 'react';
import './skeleton.scss';

const SkeletonCard = () => {
    return (
        <div className={'skeleton-package-card'}>
            <div className={'skeleton-header'}>
                <div className={'skeleton-title'}></div>
                <div className={'skeleton-icon'}></div>
            </div>
            <div className={'skeleton-divider'}></div>
            <div className={'skeleton-body'}>
                <div className={'skeleton-stat'}></div>
                <div className={'skeleton-stat'}></div>
            </div>
            <div className={'skeleton-footer'}></div>
        </div>
    );
};

export default SkeletonCard;
